import {
  ACTIVITY_FORMS_NUMBERS,
  ACTIVITY_FORMS_ORDER,
  ACTIVITY_SCHEDULE_FORMS_NUMBERS
} from 'pages/create-activity/constants';

export const isActivityFormDone = (
  formName,
  languages,
  forms,
  savedForms,
  activeTab,
  scheduleActiveSubTab,
  pricesActiveSubTab
) => {
  if (formName === 'generalForm' || formName === 'descriptionForm') {
    if (languages.length > 1) {
      const formNameSecondLanguage = `${formName}-Norwegian`;
      if (
        !forms[formNameSecondLanguage] ||
        forms[formNameSecondLanguage].syncErrors ||
        !savedForms[formNameSecondLanguage] ||
        !Object.keys(savedForms[formNameSecondLanguage]).length
      ) {
        return false;
      }
    }
  }

  if (formName === 'scheduleForm') {
    const scheduleFormName =
      ACTIVITY_FORMS_ORDER[ACTIVITY_FORMS_NUMBERS.scheduleForm][
        scheduleActiveSubTab
      ];
    if (!savedForms.scheduleTab) return false;
    if (
      !forms[scheduleFormName] ||
      forms[scheduleFormName].syncErrors ||
      !savedForms[scheduleFormName]
    ) {
      return false;
    }
    return true;
  }

  if (formName === 'pricesForm') {
    if (!forms['generalForm']) return false;
    let pricesTabIndex =
      forms['generalForm'].values.activityType === 'Open'
        ? pricesActiveSubTab + 1
        : pricesActiveSubTab;
    const pricesFormName =
      ACTIVITY_FORMS_ORDER[ACTIVITY_FORMS_NUMBERS.pricesForm][
        scheduleActiveSubTab
      ][pricesTabIndex];
    if (
      ACTIVITY_SCHEDULE_FORMS_NUMBERS.schedulePassForm === scheduleActiveSubTab
    ) {
      if (forms['generalForm'].values.activityType === 'Open') {
        pricesTabIndex = 0;
      } else {
        if (pricesActiveSubTab) {
          pricesTabIndex = 1;
        } else {
          pricesTabIndex = 0;
        }
      }
    }
    if (!savedForms.pricesTab) return false;
    if (
      !forms[pricesFormName] ||
      forms[pricesFormName].syncErrors ||
      !savedForms[pricesFormName]
    ) {
      return false;
    }
    return true;
  }

  if (!forms[formName] || forms[formName].syncErrors || !savedForms[formName]) {
    return false;
  }

  return true;
};
